import { PaziaInput, PaziaSelect } from "components/atoms";
import { useState } from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import * as yup from "yup";

interface SectionMarginsConfigProps {
  namePrefix?: string;
}

const containerWidthOptions = [
  { value: "", label: "(nie zmieniaj)" },
  { value: "default", label: "Domyślna (max-w-8xl)" },
  { value: "narrow", label: "Wąska (~896px, dobre dla tekstu)" },
  { value: "medium", label: "Średnia (~1152px)" },
  { value: "wide", label: "Szeroka (1536px)" },
  { value: "full", label: "Pełna szerokość (full-bleed)" },
];

export const SectionMarginsConfig = ({ namePrefix = "margins" }: SectionMarginsConfigProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="border-t border-slate-200 pt-4 dark:border-slate-600">
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex w-full items-center justify-between text-left"
      >
        <h4 className="font-medium text-slate-700 dark:text-slate-300">Marginesy i kontener sekcji</h4>
        {isExpanded ? (
          <MdExpandLess size={20} className="text-slate-500" />
        ) : (
          <MdExpandMore size={20} className="text-slate-500" />
        )}
      </button>

      {isExpanded && (
        <div className="mt-4 space-y-4">
          <div>
            <PaziaSelect
              name={`${namePrefix}.containerWidth`}
              label="Szerokość kontenera"
              options={containerWidthOptions}
              isClearable={false}
              placeholder="(nie zmieniaj)"
            />
          </div>

          <div>
            <p className="mb-2 text-sm text-slate-600 dark:text-slate-400">Górny margines (px)</p>
            <div className="grid gap-3 md:grid-cols-3">
              <PaziaInput
                name={`${namePrefix}.marginTop.mobile`}
                label="Mobile"
                type="number"
                placeholder="64"
              />
              <PaziaInput
                name={`${namePrefix}.marginTop.desktop`}
                label="Desktop"
                type="number"
                placeholder="96"
              />
              <PaziaInput
                name={`${namePrefix}.marginTop.xl`}
                label="XL"
                type="number"
                placeholder="96"
              />
            </div>
          </div>

          <div>
            <p className="mb-2 text-sm text-slate-600 dark:text-slate-400">Dolny margines (px)</p>
            <div className="grid gap-3 md:grid-cols-3">
              <PaziaInput
                name={`${namePrefix}.marginBottom.mobile`}
                label="Mobile"
                type="number"
                placeholder="64"
              />
              <PaziaInput
                name={`${namePrefix}.marginBottom.desktop`}
                label="Desktop"
                type="number"
                placeholder="96"
              />
              <PaziaInput
                name={`${namePrefix}.marginBottom.xl`}
                label="XL"
                type="number"
                placeholder="96"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const marginValueSchema = yup.object({
  mobile: yup.number().min(0, "Wartość musi być >= 0").default(64),
  desktop: yup.number().min(0, "Wartość musi być >= 0").default(96),
  xl: yup.number().min(0, "Wartość musi być >= 0").optional(),
});

export const marginsSchema = yup.object({
  marginTop: marginValueSchema,
  marginBottom: marginValueSchema,
  containerWidth: yup.string().oneOf(["default", "narrow", "medium", "wide", "full"]).optional(),
});

export const MARGINS_FORM_NAME = "margins" as const;
